import routerOptions0 from "/home/runner/work/nuxt.com/nuxt.com/node_modules/.pnpm/nuxt@3.16.2_@parcel+watcher@2.5.1_@types+node@22.13.10_better-sqlite3@11.9.1_db0@0.3.1__5681d482b2db0cd994aed1af98ccf4be/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "smooth"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}